import { SETTINGS } from '../configs/common.settings';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  constructor(private http: HttpClient) {}

  createTask(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/task/create`, payload);
  }
  getPagedTasks(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/task/get-paged`, payload);
  }
  getTasksOptions(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/task/get-options`);
  }
  updateTask(payload: any): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/task/update`, payload);
  }
  getOneTaskId(taskId: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/task/get-one/${taskId}`);
  }
  getPagedClientTasks(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/task/get-paged-by-client-id`,
      payload
    );
  }
}
